import React, { useEffect,useState } from "react";
import { observer } from "mobx-react";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormHelperText from "@mui/material/FormHelperText";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import {useDropzone} from 'react-dropzone';
import { IconText } from "TemplateCerere";

import { convertBytesToMbsOrKbs, getFileType } from "Utils";
import "./dropZone.scss"

function DropZone(props) {
  const { doc, onClose, onSave, open, errors } = props;
    const [acceptedFileType, setAcceptedFileType] = useState();
    const [files, setFiles] = useState([]);
    const [error, setError] = useState(null);
    const filesLimit= 1;
    
    //compun lista de fisiere acceptate    
    useEffect(() => {
      var fileType={};
          doc?.Params?.ext?.split(",")?.forEach(e => {
          var eType = getFileType(e.replace('.',''));
          var eList = fileType[eType]??[];
          if (eType){
            eList.push(e);
            fileType[eType]= eList;
          }
      });
      setAcceptedFileType(fileType);
    },[])

  const maxFileSize = (doc.Params.maxfilesize || 5 * 1024 * 1024) * 1;
  const { rejectedFiles, getRootProps, getInputProps} = useDropzone( {
      maxFiles: filesLimit,
      accept: acceptedFileType,
      maxSize: maxFileSize,
      multiple: false,
      onDropAccepted: (files) => {setFiles([files[0]]);},
      onDropRejected: (files) => { 
        var errorList=[];
        files.forEach((f)=>{
        f.errors?.forEach(e=>{
          if(e.code=="file-invalid-type") 
            errorList.push(( errors.acceptedFiles ||"Acest tip de fisier nu este suportat. "));
          if(e.code=="file-too-large") 
            errorList.push((errors.maxFileSize ||"Fisierul este prea mare. Marimea maxima admisa este " + convertBytesToMbsOrKbs(maxFileSize) +". "));
          if(e.code=="too-many-files") 
            errorList.push((errors.filesLimit ||"Numarul maxim de fisiere permise este depasit. Numarul de fisiere permise este ".concat(filesLimit,".")));
          //daca nu este tratata eroarea
          errorList.push( (errors.rejectedFile ||"Fisierul ".concat(f.file.name, " este respins. ")));
          });
  
      });
      setError(errorList);
    }
  });
  /* const errorsMsg = ()=>{
      var errorList=[];
      rejectedFiles?.forEach((f)=>{
        return f.errors?.forEach(e=>{
          if(e.code=="file-invalid-type") 
            errorList.push(( errors.acceptedFiles ||"Acest tip de fisier nu este suportat. "));
          if(e.code=="file-too-large") 
            errorList.push((errors.maxFileSize ||"Fisierul este prea mare. Marimea maxima admisa este " + convertBytesToMbsOrKbs(maxFileSize) +". "));
          if(e.code=="too-many-files") 
            errorList.push((errors.filesLimit ||"Numarul maxim de fisiere permise este depasit. Numarul de fisiere permise este ".concat(filesLimit,".")));
          //daca nu este tratata eroarea
          errorList.push( (errors.rejectedFile ||"Fisierul ".concat(f.file.name, " este respins. ")));
          });
  
      });
      return errorList;
  };*/

  
  return (
    <FormControl required={doc.Obligatoriu} error={!!doc.error}>
      <FormGroup>

        <Dialog open={open} fullWidth >
               <DialogTitle>Incarcare Fisier</DialogTitle>
               <DialogContent>
                <div className="upload-dialog">
                {!files.length  && <div {...getRootProps({className: 'dropzone'})}>
                    <input {...getInputProps()}/>
                    <div className="dropzoneParagraph">Trage Fisierul aici sau Click</div>
                    <IconText icon="CloudUpload" className="icon-upload"/>
                  </div>}
                  {files.length>0 && <div className="file-preview"> <img src={URL.createObjectURL(files[0])} alt=""/>{files[0].name}</div>}
                  {error && <div className="error-list">
                    {error?.map((err,i) => <div key={i}> {err}</div>)}
                  </div>}
                </div>
                <div className="dialog-buttons">
                  <Button
                    className="dialog-button"
                    variant="contained"
                    color="secondary"
                    onClick={()=>{setError(null); setFiles([]); onClose()}}
                  >
                    Renunta
                  </Button>
                  <Button
                    className="dialog-button"
                    variant="contained"
                    color="primary"
                    disabled={!files}
                    //endIcon={<ArrowRight fontSize="large" />}
                    onClick={() => {
                      if(files.length==0){
                        setError(["Selectati un fisier!"]);
                        return;
                      }
                      onSave(files)}}
                  >
                    Incarca
                  </Button>

              </div>
              </DialogContent>
        </Dialog>
      </FormGroup>
      <FormHelperText>{doc.error /*|| doc.Jprop.helperText*/}</FormHelperText>
    </FormControl>
  );
}
export default observer(DropZone);
